import { GraphQLErrors } from '@apollo/client/errors';
import React, { Dispatch } from 'react';

const GraphQLErrorsContext = React.createContext<{
  gqlErrors: GraphQLErrors;
  setGqlErrors: Dispatch<GraphQLErrors>;
}>({ gqlErrors: [], setGqlErrors: () => undefined });
export default GraphQLErrorsContext;
